import { Box } from '@mui/material';
import { FC } from 'react';
import {
	FinancePlan,
	FinancePlanWithDeposit,
	RenewalRatingResponse,
} from '@acorn-portal/shared/src/services/renewalsApi';
import MonthlyPaymentSummary from './MonthlyPaymentSummary';
import PayInFullSummary from './PayInFullSummary';

export interface IPaymentOptionValue {
	method?: string;
	deposit?: boolean;
}

interface IPaymentOptions {
	paymentOptions: RenewalRatingResponse;
	value?: IPaymentOptionValue;
}

const PaymentOptionsSummary: FC<IPaymentOptions> = ({ paymentOptions, value }) => {
	return (
		<Box>
			{value?.method !== 'total' && (
				<Box
					sx={(theme) => ({
						textAlign: 'center',
						borderRadius: 2,
						overflow: 'hidden',
						border: `2px solid ${theme.palette.grey[300]}`,
						[theme.breakpoints.down('md')]: {
							width: '100%',
						},
					})}
				>
					<MonthlyPaymentSummary
						rates={
							value?.deposit
								? (paymentOptions.financePlanWithDeposit as FinancePlanWithDeposit)
								: (paymentOptions.financePlanWithoutDeposit as FinancePlan)
						}
						annualPremium={paymentOptions.annualPremium}
						insuranceTaxPercentage={paymentOptions.insurancePremiumTaxPercentage}
						policyAdministrationFee={paymentOptions.policyAdministrationFee}
						depositValue={value?.deposit ? 'yes' : 'no'}
					/>
				</Box>
			)}

			{value?.method === 'total' && (
				<Box
					sx={(theme) => ({
						textAlign: 'center',
						borderRadius: 2,
						overflow: 'hidden',
						border: `2px solid ${theme.palette.grey[300]}`,
						[theme.breakpoints.down('md')]: {
							width: '100%',
						},
					})}
				>
					<PayInFullSummary
						paymentOptions={{
							policyAdministrationFee: paymentOptions.policyAdministrationFee,
							insurancePremiumTaxPercentage: paymentOptions.insurancePremiumTaxPercentage,
							annualPremium: paymentOptions.annualPremium,
						}}
					/>
				</Box>
			)}
		</Box>
	);
};
export default PaymentOptionsSummary;
